module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ro-51182fc9671cbaa10989dbae17427f55.svg";